<script>
import LoginCandidateWide from "../atoms/Login/LoginCandidateWide.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "FoundCandidates",
    components: {LoginCandidateWide, BasicButton},
    props: {
        candidates: {
            type: Array,
            required: true
        },
    },
    computed: {
        email() {
            return this.candidates[0].email;
        }
    },
    methods: {
        redirectToAuth() {
            location.href = '/auth';
        }
    }
}
</script>

<template>
    <div class="welcome-card-illustration align-items-center justify-content-center gap-3 d-flex flex-column w-100 p-5">
        <img alt="Logo" class="align-self-center" src="/img/logo.svg" width="150">
        <div>
            <h1 class="mt-4 text-center">{{ trans('general.page.login.related_accounts.title') }}</h1>
            <p class="mb-0 label text-center">{{ trans('general.page.login.related_accounts.description') }} <b>{{email}}</b></p>
        </div>

        <div class="d-flex flex-wrap justify-content-center candidates gap-2 mt-2">
            <div class="candidate-container" v-for="candidate in candidates" :key="candidate.id">
                <slot name="candidate" :candidate="candidate">
                    <login-candidate-wide v-on="$listeners" :is-email-linked="true" :candidate="candidate"/>
                </slot>
            </div>
        </div>
        <basic-button class="btn-outline" @click="redirectToAuth" type="submit" :text="trans('general.page.login.related_accounts.button')"/>
    </div>
</template>

<style scoped>
.candidate-container {
    width: 300px; /* Set a fixed width for each candidate container */
}

@media (max-width: 496px) {
    .candidate-container {
        width: 100%; /* Set width to 100% on mobile devices */
    }
}
</style>
